import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CommandeService } from 'src/app/core/services/commande.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';


@Component({
  selector: 'app-destinatairepopup',
  templateUrl: './destinatairepopup.component.html',
  styleUrls: ['./destinatairepopup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DestinatairepopupComponent implements OnInit {

  titre: string = '';
  destinataireForm: FormGroup;
  chargement = false;
  voirBtnEnregistrer = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any
, private fb: FormBuilder
, private messageService: MessageService
, private toastService: ToastService
, public commandeService: CommandeService
, private dialogRefContact: MatDialogRef<DestinatairepopupComponent>) {
  this.destinataireForm = this.fb.group({
    id: [null],
    nom: ['', Validators.required],
    prenom: ['', Validators.required],
    telephone: ['', Validators.required],
  });
 }

  ngOnInit(): void {
    if(this.data.typeOperation == 'ajout' ) {
      this.titre = 'Ajouter un Destinataire';
    } else if(this.data.typeOperation == 'modif' ) {
      this.titre = 'Modifier un Destinataire';
      this.afficherDestinataire();
    }
  }

  afficherDestinataire() {
    this.destinataireForm.patchValue({ id: this.data.contact.id });
    this.destinataireForm.patchValue({ nom: this.data.contact.nom });
    this.destinataireForm.patchValue({ prenom: this.data.contact.prenom });
    this.destinataireForm.patchValue({ telephone: this.data.contact.telephone });

    this.destinataireForm.value['id'] = this.data.contact.id;
    this.destinataireForm.value['nom'] = this.data.contact.nom;
    this.destinataireForm.value['prenom'] = this.data.contact.prenom;
    this.destinataireForm.value['telephone'] = this.data.contact.telephone;
  }

  onSubmit() {
    if (this.destinataireForm.invalid) {
      this.destinataireForm.markAllAsTouched();
      return;
    }

    var telephone: String = this.destinataireForm.value['telephone'];
    if (telephone.length !== 10) {
      this.destinataireForm.get('telephone')?.setErrors({ 'invalidLength': true });
      return;
    }

    if (this.data.typeOperation == 'ajout') {
      this.enregistrerDestinataire();
    } else if (this.data.typeOperation == 'modif') {
      this.modifierDestinataire();
    }
  }

  enregistrerDestinataire() {
    this.chargement = true;
    this.commandeService.enregistrerDestinataire(this.destinataireForm.value).subscribe(
      (reponse) => {
        this.chargement = false;
        this.destinataireForm.patchValue({ id: reponse.id });
        this.toastService.succes('Destinataire enregistré avec succès');
        this.dialogRefContact.close(this.destinataireForm.value);
      },
      (erreur) => {
        this.chargement = false;
        this.voirBtnEnregistrer = true;
        this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
      }
    );
  }

  modifierDestinataire() {
    this.chargement = true;
    this.commandeService.modifierDestinataire(this.destinataireForm.value).subscribe(
      (reponse) => {
        this.chargement = false;
        this.toastService.succes('Destinataire modifié avec succès');
        this.dialogRefContact.close(this.destinataireForm.value);
      },
      (erreur) => {
        this.chargement = false;
        this.voirBtnEnregistrer = true;
        this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
      }
    );
  }
}
